import { FieldArrayRenderProps, useField } from "formik";
import { FrequencyArray, InvestmentFundType } from "../../../redux-store/types/api-types";
import { MandateCreation, MandateListItem, MandatesListResBody } from "../../../redux-store/types/investorProfile";
import { Box, Button, CircularProgress, Grid, Hidden, IconButton, Skeleton, Tab, Tabs, Theme, Tooltip, Typography, useTheme } from "@mui/material";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import React, { useCallback, useEffect, useState } from "react";
import { RootStateType } from "../../../redux-store/reducers";
import { checkImageExists, findNextValidDate, formatCurrency, getDisplayRiskLabel, toINR, isRMLikeRole } from "../../../utils/utilityFunctions";
import { BlueEditIcon, DeleteIcons, EditIcon, InfoIconOutlined } from "../../../assets/SvgIcons";
import AlertModel from "../common/AlertModel";
import AddBankModal from "../common/AddBankModal";
import Lumpsum from "./Lumpsum"
import Sip from "./Sip";
import { isArray } from "lodash";
import { setCheckedHoldingSchemes, setSelectedAllHoldingsInfo, setSelectedHoldingsInfo } from "../../../redux-store/actions/investorProfile";
import { ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD, MPOWER_ACCOUNT_TYPE_MASTER, USER_ROLES } from "../../../utils/constant";
import { GetOrderEntryBanksListResponseBody } from "../../../redux-store/types/orderManagement";
import LumpsumSIP from "./LumpsumSIP";
import { MFSubmitButton } from "../../../lib/formik";
import dayjs from "dayjs";

interface CardProps {
    isLoading: boolean;
    // data: InvestmentFundType;
    id: string | number;
    arrayhelper: FieldArrayRenderProps,
    handleDelete: (id: number | string, folio?: string, selectedUniqueId?: string) => void,
    clientCode?: string,
    activeMandateList: Array<MandateListItem>
    folio: { folioId: string, schemeId: string, marketValue: string, investedValue: string, id: string }[]
    selectedSchemes: string[]
    isSubmitting: boolean;
    bankAccountList?: GetOrderEntryBanksListResponseBody;
    isBankBalanceObjLoading?: boolean;
    mandatesListRes?: MandatesListResBody;
    isComingFromIndFund?: boolean;
    banksList?: Array<MandateCreation>
}


// Array Card
const Card = (props: CardProps) => {
    const { isLoading, id, //data,
        arrayhelper, handleDelete, clientCode, activeMandateList, folio, selectedSchemes, isSubmitting, bankAccountList, isBankBalanceObjLoading = false, mandatesListRes, isComingFromIndFund, banksList } = props;
    const { form: { values, resetForm, setValues, errors, setErrors, setTouched, setFieldValue } } = arrayhelper

    const dispatch = useDispatch()
    const { palette } = useTheme();
    const history = useHistory();
    const { pathname } = history.location
    const [tabList] = useState(isComingFromIndFund ? ['SIP'] : ['Lumpsum', 'SIP']);
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    const [isAccordionOpen, setAccordionOpen] = useState(true);
    const {
        selectAllHoldingsInfo,
        selectedHoldingsInfo
    } = useSelector((store: RootStateType) => store.investorProfile);
    const {
        role = '',
    } = useSelector((store: RootStateType) => store.auth);
    const {
        selectedPortfolioObj
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);

    const [open, setOpen] = useState(false);
    const [openBankModal, setOpenBankModal] = useState(false);

    const [field, meta, helpers] = useField(`fund[${id}].activeTab`);

    const filterFolio = folio?.[id as number]

    const isInvestMore = pathname.split('/')[pathname.split('/').length - 1] === 'invest-more'

    const handleSuccess = () => {
        // console.log('success')
        field?.onChange(tabList[1])
    }


    const handleClose = useCallback(() => {
        setOpen(false)
    }, [])

    const handleBankClose = useCallback(() => {
        setOpenBankModal(false)
    }, [])

    const handleDeleteCardValue = (scheme: string, selectedUniqueId?: string) => {
        if (isInvestMore) {
            // const modifiedSelectedHoldingsInfo = selectedHoldingsInfo.filter(({ checkedId }) => checkedId !== scheme)
            // const modifiedSelectedAllHoldingsInfo = selectAllHoldingsInfo.filter(({ id: checkedId }) => checkedId !== id)

            const modifiedSelectedHoldingsInfo = selectedHoldingsInfo.filter(({ uniqueId }) => (uniqueId !== selectedUniqueId))
            const modifiedSelectedAllHoldingsInfo = selectAllHoldingsInfo.filter(({ uniqueId }) => (uniqueId !== selectedUniqueId))

            dispatch(setSelectedHoldingsInfo([...modifiedSelectedHoldingsInfo]))
            dispatch(setSelectedAllHoldingsInfo([...modifiedSelectedAllHoldingsInfo]))

            history.replace({
                state: ({
                    selectedSchemes: [...modifiedSelectedAllHoldingsInfo],
                    clientCode,
                    schemeDetails: modifiedSelectedAllHoldingsInfo?.map((obj) => ({
                        scheme_id: obj?.schemeId ?? "-",
                        isReinvestment: obj?.isReinvest ?? "-"
                    })),
                    folio: [...modifiedSelectedHoldingsInfo],
                })
            })

            const newValues = values.fund.filter((item: any) => {
                return (item?.uniqueId !== selectedUniqueId)
            })

            resetForm({
                values: {
                    fund: newValues,
                    ...((
                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                        isRMLikeRole(role) &&
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        documents: values?.documents ?? []
                    } : {}),
                    ...((
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        bankAccountNumber: values?.bankAccountNumber ?? ""
                    } : {})
                }
            })
            const folioId = folio[id as number]

            handleDelete(scheme, folioId?.id, selectedUniqueId)

        } else {
            const newValues = values.fund.filter((item: any) => {
                return isInvestMore ? item?.folio?.id !== scheme : item?.schemeId !== scheme
            })

            resetForm({
                values: {
                    fund: newValues,
                    ...((
                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                        isRMLikeRole(role) &&
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        documents: values?.documents ?? []
                    } : {}),
                    ...((
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        bankAccountNumber: values?.bankAccountNumber ?? ""
                    } : {})
                }
            })
            const folioId = folio[id as number]



            handleDelete(scheme, folioId?.id)
        }
    }

    const handleEditAccordionOpen = () => {
        setAccordionOpen(true);
    }

    const investmentList = (pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more') ? [
        {
            title: values.fund[id]?.detailsList?.[0]?.title || 'Aum',
            value: Number(values.fund[id]?.detailsList?.[0]?.value) ? formatCurrency({ value: Number(values.fund[id]?.detailsList?.[0]?.value), locale, currencyCode }) : "-",
        },
        {
            title: values.fund[id]?.detailsList?.[1]?.title || "NAV: -",
            value: Number(values.fund[id]?.detailsList?.[1]?.value) ? formatCurrency({ value: Number(values.fund[id]?.detailsList?.[1]?.value), locale, currencyCode }) : "-",
        },
        {
            title: values.fund[id]?.detailsList?.[2]?.title || "Invested Value",
            value: Number(values.fund[id]?.detailsList?.[2]?.value).toFixed(2) + '%' || "-",
        },
        {
            title: values.fund[id]?.detailsList?.[3]?.title || "Market Value",
            value: values.fund[id]?.detailsList?.[3]?.value || "-",
        }
    ] : [
        {
            title: 'Folio',
            value: filterFolio?.folioId || "-",
        },
        {
            title: values.fund[id]?.detailsList?.[1]?.title || "NAV: -",
            value: Number(values.fund[id]?.detailsList?.[1]?.value) ? formatCurrency({ value: Number(values.fund[id]?.detailsList?.[1]?.value), locale, currencyCode }) : "-",
        },
        {
            title: "Invested Value",
            value: Number(filterFolio?.investedValue) ? formatCurrency({ value: Number(filterFolio?.investedValue), locale, currencyCode }) : "-",
        },
        {
            title: "Market Value",
            value: Number(filterFolio?.marketValue) ? formatCurrency({ value: Number(filterFolio?.marketValue), locale, currencyCode }) : "-",
        },
    ]

    const amcIds = ['BDOTR', 'BPIAMC']

    const checkAmcId = amcIds.includes(values.fund[id].fundAmcId ?? '') ? values.fund[id].fundAmcId?.toLowerCase() : values.fund[id].fundAmcId;

    const mandateStatus = activeMandateList?.length > 0 ? activeMandateList?.[0]?.status?.toLowerCase() === 'under process' ? 'pending' : 'active' : '';

    const handleChange = async (event: React.SyntheticEvent, newValue: string) => {
        const current = { ...values }
        // const currentError = { ...errors }
        current.fund[id].activeTab = newValue
        const sipTxns = values.fund[id]?.frequencies?.filter((freq: any) => freq?.transactionType === 'SIP')
        const sipValidations = values.fund[id]?.validations?.filter((freq: any) => freq?.transactionType === 'SIP')
        const monthlyTxn = sipTxns?.find((
            txn: any) => txn.frequency?.toLowerCase() === 'monthly'
        );
        const selectedFrequency = monthlyTxn?.frequency || sipTxns[0]?.frequency;
        const matchingTxns = sipValidations?.filter((
            txn: any) => txn?.frequency?.toLowerCase() === (selectedFrequency ?? "")?.toLowerCase()
        );
        const maximumInstallments = matchingTxns?.[0]?.maximumInstallments || 0;

        const firstActiveMandate = activeMandateList?.filter((mandate: MandateListItem) => Number(mandate?.amount) >= 25000)?.[0];
        const isActiveMandPresent = Object.keys(firstActiveMandate ?? {}).length > 0;
        const investmentDates = matchingTxns?.[0]?.investmentDates || [];



        if (newValue === tabList[0]) {
            current.fund[id].sip = {
                sipamount: '25000',
                periods: selectedFrequency || '',
                installments: maximumInstallments || '',
                // sipDate: isActiveMandPresent ? dayjs().add(1, 'day').format("YYYY-MM-DD") : dayjs().add(31, 'days').format("YYYY-MM-DD"),
                sipDate: findNextValidDate(investmentDates, isActiveMandPresent ? 'active' : 'pending', true, selectedFrequency),
                // mandate: values.fund[id]?.mandate[0]?.mandateId || '',
                sipFolio: values.fund[id]?.folios?.availableFolios[0] || '',
                // firstOrder: mandateStatus === 'pending' ? true : false,
                mandateCreationDate: activeMandateList?.[0]?.startDate || '',
                mandate: {
                    mandateId: "",
                    amount: '100000',
                    accountNo: !isActiveMandPresent ? banksList?.[0]?.bankAccountNumber : firstActiveMandate?.accountNo ?? "",
                    ifscCode: '',
                    bankName: !isActiveMandPresent ? banksList?.[0]?.bankName : firstActiveMandate?.bankName ?? '',
                    startDate: dayjs().format("YYYY-MM-DD"),
                    endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                    curMandateStatus: "",
                },
                firstOrder: true,
                curMandateStatus: isActiveMandPresent ? 'active' : 'pending',
                pending: {
                    amount: '100000',
                    accountNo: !isActiveMandPresent ? banksList?.[0]?.bankAccountNumber : '',
                    ifscCode: '',
                    bankName: !isActiveMandPresent ? banksList?.[0]?.bankName : '',
                    startDate: dayjs().format("YYYY-MM-DD"),
                    endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                },
                active: {
                    mandateId: isActiveMandPresent ? firstActiveMandate?.mandateId : '',
                },
                freshMandatePayload: {},
                sipEndDate: '',
            }
        } else if (newValue === tabList[1]) {
            current.fund[id].lumpsum = {
                lumpAmount: '50000',
                lumpsumFolio: values.fund[id]?.folios?.availableFolios[0] || '',
            }
        } else if (newValue === tabList[2]) {
            current.fund[id].lumpsumSip = {
                sipamount: '',
                periods: values.fund[id]?.frequencies?.filter((freq: any) => freq.transactionType === 'SIP')[0]?.frequency || '',
                installments: '',
                sipDate: '',
                mandate: values.fund[id]?.mandate[0]?.mandateId || '',
                sipFolio: values.fund[id]?.folios?.availableFolios[0] || '',
            }
        }

        setValues(current)
    };

    const tabKeyMap: Record<string, string> = {
        Lumpsum: 'lumpsum',
        SIP: 'sip',
        "Lumpsum + SIP": 'lumpsumSip',
    };

    const tabFieldMap: Record<string, string[]> = {
        lumpsum: ['lumpAmount'],
        sip: ['sipamount', 'installments', 'sipFolio', 'periods', 'sipDate', "mandate", 'sipEndDate'],
        lumpsumSip: ['lumpSumAmount', 'sipAmount', 'installments', 'sipFolio', 'periods', 'sipDate'],
    };

    const handleSave = async () => {
        const { setTouched, values } = arrayhelper.form;
        const rawTab = values.fund?.[id]?.activeTab ?? 'Lumpsum';
        const activeTab = tabKeyMap[rawTab] || 'lumpsum';


        const fields = tabFieldMap[activeTab] || [];

        const touchObject = {
            fund: values.fund.map((_: any, i: number) =>
                i === id
                    ? {
                        [activeTab]: Object.fromEntries(fields.map((f) => [f, true])),
                    }
                    : {}
            ),
        };

        const errObj = await setTouched(touchObject, true);

        // Check if there are any errors for the specific fields
        const hasErrors = fields?.some((field) => (errObj?.fund as Record<string, any>)?.[id]?.[activeTab]?.[field]) ?? false;
        if (!hasErrors) {
            setAccordionOpen(false);
        }
    };



    return (
        <Box
            sx={{
                background: palette.background.paper,
                boxShadow: 1,
                borderRadius: '20px',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: { lg: '25px', md: '35px', sm: '25px', xs: '25px' },
            }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                    width: '100%',
                    gap: '10px',
                }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        flexDirection: 'row',
                        gap: '15px',
                        overflow: 'hidden', // Ensure overflow is hidden for the parent
                        width: 'fit-content',
                        wrap: 'wrap',
                        // width: { xs: '100%', md: '80%'}
                        // width: '50%'
                    }}>
                    {isLoading ? (
                        <CircularProgress />
                    ) : (
                        <img
                            src={checkImageExists(`${checkAmcId}`) ? `/images/amcIcons/${checkAmcId}.svg` : `/images/amcIcons/default.svg`}
                            width={'40px'}
                            height={'40px'}
                            alt={'Scheme Name'}
                            style={{ borderRadius: '8px 8px 8px 8px', alignSelf: 'flex-start' }}
                        />
                    )}
                    <Box sx={{
                        // overflow: 'hidden',
                        // textOverflow: 'ellipsis',
                        // whiteSpace: 'nowrap',
                        // flexGrow: 1,
                    }}>
                        {isLoading ? (
                            <Skeleton variant="text" animation="wave" width={200} />
                        ) : (
                            <Typography
                                variant="subtitle_400"
                                color="text.primary"
                                sx={{
                                    fontWeight: '600',
                                    // maxWidth: '90%',
                                    flexWrap: 'wrap',
                                }}>
                                {' '}
                                {values.fund[id].fundName || ''}
                            </Typography>
                        )}
                        {isLoading ? (
                            <Skeleton variant="text" animation="wave" width={200} />
                        ) : (
                            <Box display={'flex'} flexDirection={'row'} gap={'5px'} sx={{ flexWrap: 'wrap' }}>
                                <Typography variant="subtitle_500" color={palette.text.secondary}
                                    sx={{
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        maxWidth: '100%',
                                    }}>
                                    {/* {data?.fundType || ''} */}
                                    {values.fund[id].fundType || ''}
                                </Typography>
                                <Typography variant="subtitle_500" color={palette.text.secondary}
                                    sx={{
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        maxWidth: '100%',
                                    }}>
                                    {/* • {data?.fundCap || ''} */}
                                    • {values.fund[id].fundCap || ''}
                                </Typography>
                                {/* {data?.riskType !== "NULL" && */}
                                {values.fund[id].riskType !== "NULL" &&
                                    <Typography variant="subtitle_500" color={palette.text.secondary}
                                        sx={{
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            maxWidth: '100%',
                                        }}>
                                        {/* • {data?.riskType || ''} */}
                                        • {getDisplayRiskLabel(values?.fund?.[id]?.riskType || '')}

                                    </Typography>
                                }
                            </Box>
                        )}
                        {/* {isLoading ? (
                            <Skeleton variant="text" animation="wave" width={200} />
                        ) : (
                            <Box sx={{ marginTop: "3px" }}>
                                <Typography
                                    variant="body_500"
                                    color="text.primary"
                                >
                                    ISIN:{' '}
                                    <Typography
                                        component="span"
                                        variant="body_500"
                                        color="text.secondary"
                                    >
                                        {values?.fund?.[id]?.isinCode ?? ''}
                                    </Typography>
                                </Typography>
                            </Box>
                        )} */}
                    </Box>
                </Box>
                {isLoading ? (
                    <Skeleton variant="text" animation="wave" width={100} />
                ) :
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignSelf: 'flex-start',
                        justifyContent: 'flex-end',
                        width: 'fit-content',
                        overflow: 'none',
                    }}>
                        {!isAccordionOpen && <IconButton sx={{ display: 'flex', alignItems: 'center', gap: '5px', '&:hover': { backgroundColor: 'transparent' } }} onClick={() =>
                            // handleDeleteCardValue(filterFolio?.id || data?.schemeId || '')}
                            handleEditAccordionOpen()}
                        >
                            <BlueEditIcon />
                            <Hidden only={'xs'}>
                                <Typography variant="body_500" color={palette.customColors.hyperlinkBlue}>
                                    Edit Details
                                </Typography>
                            </Hidden>
                        </IconButton>}
                        <IconButton sx={{ display: 'flex', alignItems: 'center', gap: '5px', '&:hover': { backgroundColor: 'transparent' } }} onClick={() =>
                            // handleDeleteCardValue(filterFolio?.id || data?.schemeId || '')}
                            handleDeleteCardValue(filterFolio?.id || values.fund[id].schemeId || '', values?.fund?.[id]?.uniqueId ?? '')}
                            disabled={isBankBalanceObjLoading}
                        >
                            <DeleteIcons />
                            <Hidden only={'xs'}>
                                <Typography variant="body_500" color={palette.error[500]}>
                                    Remove
                                </Typography>
                            </Hidden>
                        </IconButton>
                    </Box>

                }
            </Box>
            {!isAccordionOpen &&
                (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {values?.fund?.[id]?.activeTab?.toLowerCase() === 'lumpsum' && (
                            <Box>
                                <Typography
                                    variant="body_500"
                                    color={palette.text.secondary}
                                    sx={{
                                        mb: 1
                                    }}
                                >
                                    Lumpsum Amount
                                </Typography>
                                <Typography
                                    variant="body_600">
                                    {toINR({ value: values?.fund?.[id]?.lumpsum?.lumpAmount || 0, locale, currencyCode })}
                                </Typography>
                            </Box>
                        )}
                        {values?.fund?.[id]?.activeTab?.toLowerCase() === 'sip' && (
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography
                                    sx={{
                                        mb: 1
                                    }}
                                    variant="body_500"
                                    color={palette.text.secondary}>
                                    SIP Amount
                                </Typography>
                                <Typography
                                    variant="body_600"
                                    sx={{ alignSelf: 'flex-end' }}>
                                    {toINR({ value: values?.fund?.[id]?.sip?.sipamount || 0, locale, currencyCode })}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                )}
            {isAccordionOpen &&
                <>
                    <Grid container sx={{ rowGap: { xs: 0.8, sm: 0 } }} >
                        {/* <Hidden only={'xs'}> */}
                        {(isLoading ? [1, 2, 3] : investmentList)?.map((item: any, key) => (
                            <Grid item lg={3} md={6} sm={6} xs={12} key={key} sx={{
                                justifyContent: 'space-between',
                                display: 'flex',
                                flexDirection: { xs: 'row', sm: 'column', md: 'column', lg: 'column' },
                                gap: "10px"


                            }}>
                                {isLoading ? (
                                    <Skeleton variant="text" animation="wave" width={100} />
                                ) : (
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {item.title !== "Exit Load" && (
                                            <Typography variant="subtitle_400" color={palette.text.secondary} textTransform={'capitalize'}
                                            >
                                                {item?.title}
                                            </Typography>
                                        )}
                                        {/* {item?.title === 'Exit Load' && item?.value?.length > 10 && (
                                            <Tooltip
                                                slotProps={{
                                                    tooltip: {
                                                        sx: {
                                                            margin: "0px !important",
                                                            backgroundColor: "transparent"
                                                        }
                                                    }
                                                }}
                                                title={
                                                    <Box sx={{ borderRadius: '5px', padding: '5px 10px', backgroundColor: palette.customColors.cinder }}
                                                    >
                                                        <Typography variant="body_400">
                                                            {item?.value}
                                                        </Typography>

                                                    </Box>

                                                } >
                                                <IconButton>
                                                    <InfoIconOutlined />
                                                </IconButton>
                                            </Tooltip>
                                        )} */}
                                    </Box>
                                )}

                                {isLoading ? (
                                    <Skeleton variant="text" animation="wave" width={50} />
                                ) : (
                                    // item?.title === 'Exit Load'
                                    //     ?
                                    //     (
                                    //         <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant="body_500" fontWeight={600} color={palette.text.primary}>
                                    //             {item?.value?.length > 10 ? item?.value?.slice(0, 20) + ' ...' : item?.value || '-'}
                                    //         </Typography>
                                    //     )
                                    //     : (<Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant="body_500" fontWeight={600} color={palette.text.primary}>
                                    //         {item?.value}
                                    //     </Typography>)
                                    item?.title !== "Exit Load" &&
                                    (
                                        <Typography variant="body_500" color={palette.text.primary}>
                                            {item?.value}
                                        </Typography>
                                    )
                                )}
                            </Grid>
                        ))}
                    </Grid>
                    <Box>
                        <Box
                            sx={{
                                borderBottom: `1px solid ${palette.text.secondary}99`,
                                display: 'flex',
                                flexDirection: 'row',
                                paddingBottom: { lg: '0px', md: '0px', sm: '0.1px', xs: '0.1px' },
                            }}>
                            <Tabs
                                value={field?.value}
                                onChange={handleChange}
                                sx={{
                                    '& .MuiTabs-indicator': {
                                        display: 'none'
                                    },
                                    minHeight: 28,
                                    height: 28,
                                }}
                                aria-label="Transaction type tabs"
                            >
                                {tabList.map((item, index) => (
                                    <Tab
                                        label={
                                            <Typography variant='body_500' sx={(theme: Theme) => (
                                                {
                                                    color: field?.value === item ? theme.palette.common.white : theme.palette.text.secondary,
                                                    textTransform: 'capitalize'
                                                }
                                            )}>
                                                {item}
                                            </Typography>
                                        }
                                        disabled={isLoading || isSubmitting || isBankBalanceObjLoading}
                                        sx={{
                                            minHeight: 28,
                                            height: 28,
                                            px: { xs: 0, sm: 1.5 },
                                            py: { xs: 0, sm: 1.5 },
                                            mr: 2,
                                            borderRadius: { lg: '7px 7px 0px 0px', md: '7px 7px 0px 0px', sm: '7px 7px 0px 0px', xs: '7px 7px 0px 0px' },
                                            background: field?.value === item ? palette.primary[500] : palette.grey[50]
                                        }}
                                        key={index}
                                        value={item}
                                        id={`investment-tab-${id}-${index}`}
                                        aria-controls={`investment-tabpanel-${id}`}
                                    />
                                ))}
                            </Tabs>
                        </Box>

                        <Box
                            role="tabpanel"
                            id={`investment-tabpanel-${id}`}
                            aria-labelledby={`investment-tab-${id}-${tabList.indexOf(field?.value)}`}
                            sx={{ pt: 3 }}
                        >
                            {field?.value === 'Lumpsum'
                                ?
                                (
                                    <Lumpsum isLoading={isLoading} id={id} data={values.fund[id]} isSubmitting={isSubmitting || isBankBalanceObjLoading} bankAccountList={bankAccountList} />
                                )
                                :
                                field?.value === 'SIP'
                                    ? (
                                        <Sip isLoading={isLoading} id={id} data={values.fund[id]} clientCode={clientCode} activeMandateList={activeMandateList}
                                            mandatesListRes={mandatesListRes}
                                            // valueIdentifier={filterFolio?.id || data?.schemeId || ''}
                                            valueIdentifier={filterFolio?.id || values.fund[id]?.schemeId || ''}
                                            isSubmitting={isSubmitting || isBankBalanceObjLoading}
                                            bankAccountList={bankAccountList}
                                            isComingFromIndFund
                                            banksList={banksList}
                                        />
                                    )
                                    : (
                                        <LumpsumSIP
                                            isLoading={isLoading} id={id} data={values.fund[id]} clientCode={clientCode} activeMandateList={activeMandateList}
                                            mandatesListRes={mandatesListRes}
                                            // valueIdentifier={filterFolio?.id || data?.schemeId || ''}
                                            valueIdentifier={filterFolio?.id || values.fund[id]?.schemeId || ''}
                                            isSubmitting={isSubmitting || isBankBalanceObjLoading}
                                            bankAccountList={bankAccountList} />
                                    )
                            }
                        </Box>
                    </Box>

                    <Button onClick={() => handleSave()} variant="outlined" sx={{ width: 'fit-content', padding: '7px 40px' }}>
                        <Typography variant="body_500" color={'primary.main'}>Collapse Card</Typography>
                    </Button>
                </>
            }
            {open && (
                <AlertModel
                    {...{
                        handleClose,
                        open,
                        setOpen,
                        setOpenBankModal,
                        title: 'No Mandates Available',
                        desc: 'There are currently no mandates available for completing your SIP transaction. In order to proceed with your investment, it is mandatory to have a mandate in place.',
                    }}
                />
            )}
            {openBankModal && (
                <AddBankModal
                    {...{
                        handleClose: handleBankClose,
                        handleSuccess: handleSuccess,
                        open: openBankModal,
                        setOpen: setOpenBankModal,
                        title: 'Add New Bank Mandate',
                        clientCode: clientCode,
                    }}
                />
            )}
        </Box>
    );
};

export default Card;